module.exports = __webpack_public_path__ + "9151714c38572b50cd0871d10325f993.png";